import {
    GET_LIST_JAM_KERJA_MASTERDATA,
    GET_LIST_TIM_KERJA_MASTERDATA,
    GET_LIST_UNKER_MASTERDATA,
    GET_LIST_NEGARA_MASTERDATA,
    GET_LIST_DIKLAT_JABATAN,
    GET_LIST_PROVINSI,
    GET_LIST_KOTA,
    GET_LIST_KECAMATAN,
    GET_LIST_KELURAHAN,
    GET_LIST_BAHASA_MASTERDATA,
    GET_LIST_HARI_LIBUR_MASTERDATA,
    GET_LIST_JENIS_CUTI_MASTERDATA,
    GET_LIST_JURUSAN_MASTERDATA,
    GET_LIST_UNIVERSITAS_MASTERDATA,
    GET_LIST_TINGKAT_PENDIDIKAN_MASTERDATA,
    GET_LIST_SMP,
    GET_LIST_SD,
    GET_CREATE_SEKOLAH,
    GET_LIST_SEKOLAH,
    GET_LIST_JABATAN_MASTERDATA,
    GET_LIST_KEDUDUKAN_MASTERDATA,
    GET_LIST_PP_PELANGGARAN_MASTERDATA,
    GET_LIST_JADWAL_KERJA,
} from "shared/constants/ActionTypes";

const placeholderDatas = {
    results: []
}

const placeholderData = {
    result: null,
}

const INIT_STATE = {
    jenisCuti: {
        lists: { ...placeholderDatas },

        detail: { ...placeholderData }
    },
    provinsi: {
        lists: { ...placeholderDatas },
        detail: { ...placeholderData }
    },
    pendidikanTerakhir: {
        lists: { ...placeholderDatas },
        detail: { ...placeholderData }
    },
    kelurahan: {
        lists: { ...placeholderDatas },
        detail: { ...placeholderData }
    },
    kecamatan: {
        lists: { ...placeholderDatas },
        detail: { ...placeholderData }
    },
    jurusan: {
        lists: { ...placeholderDatas },
        detail: { ...placeholderData }
    },
    tingkatPendidikan: {
        lists: { ...placeholderDatas },
        detail: { ...placeholderData }
    },
    unitKerja: {
        lists: { ...placeholderDatas },
        detail: { ...placeholderData }
    },
    jabatan: {
        lists: { ...placeholderDatas },
        detail: { ...placeholderData }
    },
    ppPelanggaran: {
        lists: { ...placeholderDatas },
        detail: { ...placeholderData }
    },
    bahasa: {
        lists: { ...placeholderDatas },
        detail: { ...placeholderData }
    },
    hariLibur: {
        lists: { ...placeholderDatas },
        detail: { ...placeholderData }
    },
    jamKerja: {
        lists: { ...placeholderDatas },
        detail: { ...placeholderData }
    },
    diklatJabatan: {
        lists: { ...placeholderDatas },
        detail: { ...placeholderData }
    },
    kedudukan: {
        lists: { ...placeholderDatas },
        detail: { ...placeholderData }
    },
    negara: {
        lists: { ...placeholderDatas },
        detail: { ...placeholderData }
    },
    kota: {
        lists: { ...placeholderDatas },
        detail: { ...placeholderData }
    },
    sekolahSD: {
        lists: { ...placeholderDatas },
        detail: { ...placeholderData }
    },
    sekolahSMP: {
        lists: { ...placeholderDatas },
        detail: { ...placeholderData }
    },
    sekolahSMA: {
        lists: { ...placeholderDatas },
        detail: { ...placeholderData }
    },
    universitas: {
        lists: { ...placeholderDatas },
        detail: { ...placeholderData }
    },
    programStudi: {
        lists: { ...placeholderDatas },
        detail: { ...placeholderData }
    },
    timKerja: {
        lists: { ...placeholderDatas },
        detail: { ...placeholderData }
    },
}

const masterDataReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_NEGARA_MASTERDATA: {
            return {
                ...state,
                negara: {
                    ...state.negara,
                    lists: action.payload
                }
            }
        }
        case GET_LIST_UNKER_MASTERDATA: {
            return {
                ...state,
                unitKerja: {
                    ...state.unitKerja,
                    lists: action.payload
                }
            }
        }
        case GET_LIST_JENIS_CUTI_MASTERDATA: {
            return {
                ...state,
                jenisCuti: {
                    ...state.jenisCuti,
                    lists: action.payload
                }
            }
        }
        case GET_LIST_DIKLAT_JABATAN: {
            return {
                ...state,
                diklatJabatan: {
                    ...state.diklatJabatan,
                    lists: action.payload
                }
            }
        }
        case GET_LIST_JURUSAN_MASTERDATA: {
            return {
                ...state,
                jurusan: {
                    ...state.jurusan,
                    lists: action.payload
                }
            }
        }
        case GET_LIST_JAM_KERJA_MASTERDATA: {
            return {
                ...state,
                jamKerja: {
                    ...state.jamKerja,
                    lists: action.payload
                }
            }
        }
        case GET_LIST_TIM_KERJA_MASTERDATA: {
            return {
                ...state,
                timKerja: {
                    ...state.timKerja,
                    lists: action.payload
                }
            }
        }
        case GET_LIST_HARI_LIBUR_MASTERDATA: {
            return {
                ...state,
                hariLibur: {
                    ...state.hariLibur,
                    lists: action.payload
                }
            }
        }
        case GET_LIST_PROVINSI: {
            return {
                ...state,
                provinsi: {
                    ...state.provinsi,
                    lists: action.payload,
                }
            }
        }
        case GET_LIST_KOTA: {
            return {
                ...state,
                kota: {
                    ...state.kota,
                    lists: action.payload
                }
            }
        }
        case GET_LIST_KECAMATAN: {
            return {
                ...state,
                kecamatan: {
                    ...state.kecamatan,
                    lists: action.payload
                }
            }
        }
        case GET_LIST_UNIVERSITAS_MASTERDATA: {
            return {
                ...state,
                universitas: {
                    ...state.universitas,
                    lists: action.payload
                }
            }
        }
        case GET_LIST_TINGKAT_PENDIDIKAN_MASTERDATA: {
            return {
                ...state,
                tingkatPendidikan: {
                    ...state.tingkatPendidikan,
                    lists: action.payload
                }
            }
        }
        case GET_LIST_KELURAHAN: {
            return {
                ...state,
                kelurahan: {
                    ...state.kelurahan,
                    lists: action.payload
                }
            }
        }
        case GET_LIST_BAHASA_MASTERDATA: {
            return {
                ...state,
                bahasa: {
                    ...state.bahasa,
                    lists: action.payload
                }
            }
        }
        case GET_LIST_SMP: {
            return {
                ...state,
                sekolahSMP: {
                    ...state.sekolahSMP,
                    lists: action.payload
                }
            }
        }
        case GET_LIST_JABATAN_MASTERDATA: {
            return {
                ...state,
                jabatan: {
                    ...state.jabatan,
                    lists: action.payload
                }
            }
        }
        case GET_LIST_SD: {
            return {
                ...state,
                sekolahSD: {
                    ...state.sekolahSD,
                    lists: action.payload
                }
            }
        }
        case GET_LIST_KEDUDUKAN_MASTERDATA: {
            return {
                ...state,
                kedudukan: {
                    ...state.kedudukan,
                    lists: action.payload
                }
            }
        }
        case GET_LIST_PP_PELANGGARAN_MASTERDATA: {
            return {
                ...state,
                ppPelanggaran: {
                    ...state.ppPelanggaran,
                    lists: action.payload
                }
            }
        }
        case GET_LIST_SEKOLAH: {
            return {
                ...state,
                sekolahSMA: {
                    ...state.sekolahSMA,
                    lists: action.payload
                },
            }
        }
        default:
            return state;
    }
};

export default masterDataReducer;
